/**
 * Registry of project-level contracts users may sign (per user, per project).
 * Add new entries here to extend beyond YouTube license.
 */
export const PROJECT_CONTRACT_KEYS = {
  YOUTUBE_LICENSE: "youtube_license_v1",
};

export const PROJECT_CONTRACTS = {
  [PROJECT_CONTRACT_KEYS.YOUTUBE_LICENSE]: {
    key: PROJECT_CONTRACT_KEYS.YOUTUBE_LICENSE,
    title: "License Agreement",
    /** When true, absence of a YouTube platform/binding skips the gate entirely. */
    requiresYoutubeProject: true,
  },
};

export function getProjectContractConfig(contractKey) {
  return PROJECT_CONTRACTS[contractKey] || null;
}
